import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { v4 as uuid } from 'uuid';
import { Input } from '../../../components';
import { AddWhite, CloseIcon } from '../../../assets/icons';
import { clone } from '../../../utils';
import { MaintenancePlanService } from "../../../services";

const ModalCreateCategory = ({ onClose, onSuccess }) => {
  const { form, isLoading, onAdd, onChange, onChangeItem, onRemove, submit } = useForm({ onClose, onSuccess });

  return (
    <div className="w-[36rem] px-4 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">Nueva categoría</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <Input
        label="Nombre"
        value={form.name || ''}
        onValueChange={v => onChange('name', v)}
      />

      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">Subcategorías</h2>
        <button onClick={onAdd} className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold">
          <img src={AddWhite} className="w-4 h-4" alt="" />
          Agregar
        </button>
      </div>

      <div className="space-y-4">
        {form.items.map((item, index) => (
          <Input
            placeholder="Nombre"
            value={item.name}
            onValueChange={v => onChangeItem(item._id, 'name', v)}
            append={
              <button
                type="button"
                tabIndex="-1"
                onClick={() => onRemove(index)}
                className="text-gray-400"
              >
                <img src={CloseIcon} className="w-4 h-4" alt="" />
              </button>
            }
          />
        ))}
      </div>

      {!form.items.length && (
        <p className="text-center text-default py-8">Agrega una subcategoría</p>
      )}

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>
        <button
          type="button"
          className="px-6 py-2 bg-red text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm disabled:opacity-50"
          onClick={submit}
          disabled={isLoading}
        >
          Guardar
        </button>
      </div>
    </div>
  );
};

const useForm = ({ onClose, onSuccess }) => {
  const initialForm = {
    name: '',
    items: [],
  }

  const initialSubcategory = {
    _id: '',
    name: '',
  }

  const [form, setForm] = useState(clone(initialForm));
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (target, value) => {
    setForm(s => ({ ...s, [target]: value }));
  };

  const onChangeItem = (_id, target, value) => {
    const items = form.items.map((item, index) => {
      if (item._id === _id) {
        return { ...item, [target]: value };
      }
      return item;
    });

    setForm(s => ({ ...s, items }));
  };

  const onAdd = () => {
    setForm(s => ({ ...s, items: s.items.concat([{ ...initialSubcategory, _id: uuid() }]) }));
  }

  const onRemove = (index) => {
    const items = form.items.filter((_, idx) => index !== idx);
    setForm(s => ({ ...s, items }))
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    // if (!form.items.length)
    //   return onError('Debe agregar al menos una subcategoría');

    if (form.items.some(x => !x.name.trim()))
      return onError('Debe indicar el nombre de cada subcategoría');

    if (form.items.some(x => form.items.filter(y => String(y.name).toLocaleLowerCase() === String(x.name).toLocaleLowerCase())?.length > 1))
      return onError('No puede haber subcategorías duplicadas');

    return true;
  };

  const submit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      await MaintenancePlanService.admin.create(form);
      toast.success('Plan de mantenimiento creado con éxito');
      onSuccess?.();
      onClose?.();

    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  };

  return {
    form,
    isLoading,
    onAdd,
    onChange,
    onChangeItem,
    onRemove,
    submit,
  };
};

export default ModalCreateCategory;
